import React from 'react';
import { Components } from './styled';
import { EventProps } from 'react-big-calendar';
import { CalendarEvent } from '../../../../api/types/event';
import { ReactComponent as IconMinimal } from '../../../../assets/icons/icon-daily-alux-minimal.svg';
import { ReactComponent as IconReady } from '../../../../assets/icons/icon-daily-alux-ready.svg';
import ContentInsightsCard from '../../../../components/ContentInsightsCard';

const CalendarMonthEvent: React.FC<EventProps> = (e) => {
  const {
    event: { data },
  } = e as EventProps<CalendarEvent>;

  return (
    <Components.EventWrapper>
      {data?.status === 'minimal' ? (
        <Components.IconWrapper>
          <IconMinimal />
        </Components.IconWrapper>
      ) : data?.status === 'readyToPlay' ? (
        <Components.IconWrapper>
          <IconReady />
        </Components.IconWrapper>
      ) : (
        <Components.EventDot />
      )}
      <Components.EventTitle>{data?.title}</Components.EventTitle>
      <ContentInsightsCard contentType={'lesson'} cardStyle={'dailyAluxAdornment'} content={data} />
    </Components.EventWrapper>
  );
};

export default CalendarMonthEvent;
